import Vue from 'vue'

Vue.component('CardFull', resolve => { require(['@/components/core/CardFull'], resolve) })
Vue.component('Container', resolve => { require(['@/components/core/Container'], resolve) })
Vue.component('IconSvg', resolve => { require(['@/components/core/IconSvg'], resolve) })
Vue.component('Icon', resolve => { require(['@/components/core/Icon'], resolve) })
Vue.component('ButtonGroup', resolve => { require(['@/components/core/ButtonGroup'], resolve)})
